var _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvalanche(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_295_1931)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2656 0.5H6.26562C2.95192 0.5 0.265625 3.18629 0.265625 6.5V14.5C0.265625 17.8137 2.95192 20.5 6.26562 20.5H14.2656C17.5793 20.5 20.2656 17.8137 20.2656 14.5V6.5C20.2656 3.18629 17.5793 0.5 14.2656 0.5Z",
    fill: "#1B1B1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2656 0.5H6.26562C2.95192 0.5 0.265625 3.18629 0.265625 6.5V14.5C0.265625 17.8137 2.95192 20.5 6.26562 20.5H14.2656C17.5793 20.5 20.2656 17.8137 20.2656 14.5V6.5C20.2656 3.18629 17.5793 0.5 14.2656 0.5Z",
    fill: "#E84142",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_295_1931)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_295_1931",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.599 0.5H6.93229C3.25039 0.5 0.265625 3.48477 0.265625 7.16667V13.8333C0.265625 17.5152 3.25039 20.5 6.93229 20.5H13.599C17.2809 20.5 20.2656 17.5152 20.2656 13.8333V7.16667C20.2656 3.48477 17.2809 0.5 13.599 0.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_295_1931)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.21043 15.5574H5.1472C4.71365 15.5574 4.4995 15.5574 4.36893 15.4738C4.22789 15.3824 4.1417 15.2309 4.13126 15.0637C4.12341 14.9097 4.2305 14.7217 4.44466 14.3456L9.53904 5.36602C9.75579 4.98471 9.86545 4.79406 10.0039 4.72355C10.1528 4.64781 10.3304 4.64781 10.4792 4.72355C10.6176 4.79406 10.7274 4.98471 10.9441 5.36602L11.9915 7.19421L11.9968 7.20354C12.2309 7.61261 12.3496 7.82005 12.4015 8.03777C12.4589 8.27544 12.4589 8.52616 12.4015 8.76383C12.3492 8.98316 12.2317 9.19216 11.994 9.60741L9.31804 14.3377L9.31112 14.3498C9.07545 14.7622 8.95604 14.9713 8.79054 15.129C8.61029 15.3014 8.39353 15.4267 8.15586 15.4973C7.9391 15.5574 7.69621 15.5574 7.21043 15.5574ZM12.4208 15.5574H15.3771C15.8133 15.5574 16.0327 15.5574 16.1634 15.4713C16.3044 15.3799 16.3931 15.2257 16.401 15.0587C16.4085 14.9096 16.3038 14.7288 16.0985 14.3746C16.0915 14.3626 16.0844 14.3502 16.0772 14.3377L14.5963 11.8044L14.5795 11.7759C14.3714 11.424 14.2663 11.2463 14.1314 11.1777C13.9826 11.1019 13.8075 11.1019 13.6587 11.1777C13.5229 11.2482 13.4132 11.4336 13.1965 11.8071L11.7209 14.3404L11.7158 14.3491C11.4998 14.722 11.3918 14.9083 11.3996 15.0612C11.41 15.2284 11.4962 15.3824 11.6373 15.4738C11.7652 15.5574 11.9846 15.5574 12.4208 15.5574Z",
    fill: "#E84142"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_295_1931"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.265625 0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_295_1931"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.265625 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvalanche);
export default __webpack_public_path__ + "static/media/avalanche.16526a76b39230ce5986e79b0c40eb5a.svg";
export { ForwardRef as ReactComponent };